import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { sortItems } from 'shared/utils/sort-items';

import { useSmartLists } from './use-smart-lists';

type UseSortedSmartListsOptions = {
  excludeFrozen?: boolean;
};

export const useSortedSmartLists = (options?: UseSortedSmartListsOptions) => {
  const user = useUser();
  const smartLists = useSmartLists(options);
  const smartListSorting = user?.settings?.smartListSorting;

  return useMemo(() => {
    if (!smartListSorting?.length) {
      return smartLists;
    }

    return sortItems(smartLists, smartListSorting, 'id');
  }, [smartLists, smartListSorting]);
};
